export enum CloseButtonSizeEnum {
  SM = 'sm',
  MD = 'md',
}
